import { partnerClient } from '@modules/core/services';

import { FindPatientIdParams, PatientProfileResponse } from '../types';

export const findByPatientId = async ({
  patientId,
}: FindPatientIdParams): Promise<PatientProfileResponse | undefined> => {
  return await partnerClient.post('/patients/lookup', {
    externalID: patientId,
  });
};
